/// <amd-module name="Test/TestResultWorkItems/Components/ConfirmationDialog" />
import { IButtonProps } from "VSSUI/Button";
import { Dialog } from "VSSUI/Dialog";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Resources from 'Test/TestResultWorkItems/Resources';
import { IVssComponentProperties, VssComponent } from 'VSS/Platform/Layout';

export enum ConfirmationDialogType{
    Alert,
    Confirm
}

export interface IProps extends IVssComponentProperties {
    title?: string;
    message: string;
    type: ConfirmationDialogType;
    onConfirm?: () => void;
    onCancel?: () => void;
}

export function openConfirmationDialog(message: string, onConfirm: () => void, onCancel?: () => void) {
    // Render Dialog
    let container = document.createElement("div");

    let props: IProps = {
        title: Resources.ConfirmText,
        message: message,
        type: ConfirmationDialogType.Confirm,
        onConfirm: onConfirm,
        onCancel: () => {
            ReactDOM.unmountComponentAtNode(container);
            if (onCancel) {
                onCancel();
            }
        }
    };
    ReactDOM.render(React.createElement(ConfirmationDialog, props), container);
}

export function openAlertDialog(message: string, onCancel ?: () => void) {
    // Render Dialog
    let container = document.createElement("div");

    let props: IProps = {
        message: message,
        type: ConfirmationDialogType.Alert,
        onCancel: () => {
            ReactDOM.unmountComponentAtNode(container);
            if (onCancel) {
                onCancel();
            }
        }
    };
    ReactDOM.render(React.createElement(ConfirmationDialog, props), container);
}

export class ConfirmationDialog extends VssComponent<IVssComponentProperties> {

    public render(): JSX.Element {
        return (<Dialog
            calloutContentClassName="confirm-discard-dialog"
            calloutClassName="tcm-confirm-dialog bowtie-fabric"
            onDismiss={this._closeDialog}
            lightDismiss={false}
            footerButtonProps={this._getFooterButtonProps()}
            showCloseButton={true}
            titleProps={{ text: this.props.title }}>
            <div>
                {this.props.message}
            </div>
        </Dialog>);
    }

    private _getFooterButtonProps = (): IButtonProps[] => {
        const buttonProps = [{ className:"tcm-confirm", onClick: this._onConfirmClick, ariaLabel: Resources.OkText, text: Resources.OkText}];
        if (this.props.type === ConfirmationDialogType.Confirm) {
            buttonProps.push({ className: "tcm-cancel", onClick: this._closeDialog, ariaLabel: Resources.CancelText, text: Resources.CancelText});
        }
        return buttonProps;
    }

    private _onConfirmClick = () => {
        if (this.props.onConfirm) {
            this.props.onConfirm();
        }
        this._closeDialog();
    }

    private _closeDialog = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
}

